import {AppModal} from "./index";
import IconQuestionCircle from "./icons/question-circle";
import {Colors} from "../types/core-types";

interface IConfirmationModalProps {
    isOpen: boolean,
    onCancel: (value: boolean) => void,
    onConfirm: (value: boolean) => void,
    title?: string,
    message?: string,
    confirmButtonLabel?: string,
    icon?: React.ReactNode,
    iconColor?: Colors
    withLoadingButton?:boolean;
}

export default function ConfirmationModal({
                                              title = "Confirm Action",
                                              message = "Make sure all details are correct before continuing.",
                                              isOpen,
                                              onCancel,
                                              onConfirm,
                                              icon = <IconQuestionCircle/>,
                                              confirmButtonLabel = "Save",
                                              iconColor = 'info',
                                              withLoadingButton = false
                                          }: IConfirmationModalProps) {
    return (
        <AppModal
            opened={isOpen}
            onClose={() => onCancel(false)}
            onSave={() => onConfirm(false)}
            titleIcon={icon}
            title={title}
            iconColor={iconColor}
            confirmButtonLabel={confirmButtonLabel}
            withLoadingButton={withLoadingButton}
        >
            <div dangerouslySetInnerHTML={{__html: message}}></div>
        </AppModal>
    )
}